/** @titleBy question */
export interface Question {
    /**
     * @title Pergunta
     */
    question: string

    /**
     * @title Resposta
     * @format html
     */
    answer: string
}

export interface Props {
    /**
     * @title Perguntas
     */
    questions?: Question[]
}

export default function FAQ({ questions }: Props) {
    if (!questions?.length) return null

    return (
        <ul className='max-w-[1024px] px-3.5 mx-auto my-8 grid gap-3'>
            {questions.map(({ question, answer }) => (
                <li className='collapse collapse-plus border border-[#d7d7d7] rounded-none'>
                    <input className='min-h-max' type='checkbox' aria-label='Abrir Pergunta' />

                    <h3 className='collapse-title min-h-max py-4 pl-5 pr-12 text-sm after:!w-max after:!h-max after:text-2xl after:font-black after:!top-6 after:-translate-y-1/2 after:!right-5'>
                        {question}
                    </h3>

                    <div
                        className='collapse-content px-5 text-sm [&_a]:text-salmon [&_ul]:list-disc [&_ul]:list-inside'
                        dangerouslySetInnerHTML={{ __html: answer }}
                    />
                </li>
            ))}
        </ul>
    )
}
